import React from 'react'
import {
  Grid
} from '@material-ui/core';
import ConditionFormula from '../TriggerAction/ConditionFormula';
import ConditionTrue from '../TriggerAction/ConditionTrue';
import ConditionFalse from '../TriggerAction/ConditionFalse';
import FormulaHelper from '../TriggerAction/FormulaHelper';

const ContainerFormula = ({question ,handleChange}) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <FormulaHelper handleChange={handleChange} />
      </Grid>
      <Grid item xs={12}>
        <ConditionFormula conditionFormula={question.trigger_action.condition_formula} handleChange={handleChange} />
      </Grid>
      <Grid item xs={4}>
        <ConditionTrue conditionTrue={question.trigger_action.condition_true} handleChange={handleChange} />
      </Grid>
      <Grid item xs={4}>
        <ConditionFalse conditionFalse={question.trigger_action.condition_false} handleChange={handleChange} />
      </Grid>
    </Grid>
  )
}

export default ContainerFormula
